(ns frontend.view.modals.association.single-view
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.schema.associations :as associations]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.view.entity :as f-entity]
   [ui.editors.labelled-input.view :as labelled-input]))

(def hide-options-for-tenant
  {"Equity Pitcher" [:association.type/bu-responsible :association.type/group-contact-person
                     :association.type/lead-investor-contact-person]})

(defn visible-for-tenant
  [association-type entity-type target-type]
  (let [non-person-type (if (= :entity.type/person target-type)
                          entity-type
                          target-type)
        person? (some #{:entity.type/person} [entity-type target-type])]
    (cond
      ;; These used to be only for tenant "Liechtenstein Group"
      ;; TODO refactor (possibly remove these association-types altogether):
      (some #{association-type} [:association.type/main-holding :association.type/sub-holdings])
      false

      ;; TESI
      (and (tenant-customizations/tesi?)
           person?
           (some #{non-person-type} [:entity.type/holding :entity.type/company :entity.type/investor]))
      (some #{association-type}
            (cond
              (= non-person-type :entity.type/investor)
              [:association.type/advisor-consultant
               :association.type/associate
               :association.type/board-member
               :association.type/esg-specialist
               :association.type/cfo
               :association.type/chairman-of-the-board
               :association.type/contact-person
               :association.type/director
               :association.type/managing-partner
               :association.type/other
               :association.type/partner
               :association.type/relevant-network
               :association.type/secondary-contact-person]
              (some #{non-person-type} [:entity.type/company :entity.type/holding])
              [:association.type/advisor-consultant
               :association.type/assistant-or-secretary
               :association.type/associate
               :association.type/board-member
               :association.type/ceo
               :association.type/esg-specialist
               :association.type/cfo
               :association.type/chairman-of-the-board
               :association.type/co-founder
               :association.type/contact-person
               :association.type/coo
               :association.type/cto
               :association.type/director
               :association.type/founder
               :association.type/lead-investor-contact-person
               :association.type/board-observer
               :association.type/other
               :association.type/relevant-network
               :association.type/secondary-contact-person]
              :else
              []))
      :else true)))

(defn view
  [{:keys [props state]}]
  (let [{:keys [entity-id entity-type target-type create-on-fly?]} props
        hidden-for-tenant (get hide-options-for-tenant @session/tenant-name)
        association-type-options (some->> associations/schema
                                          (cu/flip get entity-type)
                                          (cu/flip get target-type)
                                          (keep (fn [[a-t _c]]
                                                  (when (and (visible-for-tenant a-t entity-type target-type)
                                                             (not (some #{a-t} hidden-for-tenant)))
                                                    {:key   a-t
                                                     :label (loc/tr a-t)})))
                                          (sort-by :label))
        association-types (:association-types @state)]
    [:<>
     [:div
      {:class "flex flex-col gap-4"}
      [labelled-input/view
       (cond-> {:editor-type               :editor.type/search
                :data-type                 :data.type/ref-single
                :label                     (loc/tr :select-entity [(loc/tr target-type)])
                :mandatory?                true
                :field/entity-types        [target-type]
                :field/select-entity-types [target-type]
                :exclude-values            (when (not= target-type :entity.type/person)
                                             [entity-id])
                :value                     (:value-opt @state)
                :on-change                 (fn [_value option]
                                             (swap! state assoc
                                                    :target-id (:value option)
                                                    :value-opt option))}
         create-on-fly?
         (assoc :field/create-entity-types [target-type]
                :create! (fn [input-str]
                           (f-entity/open-creator!
                            target-type
                            {:start-value       input-str
                             :skip-success-msg? true
                             :on-ok!            (fn [{:keys [new-entity-id new-entity close-cb!]}]
                                                  (let [opt {:value new-entity-id
                                                             :label (entity/display-string new-entity)}]
                                                    (swap! state assoc
                                                           :target-id new-entity-id
                                                           :value-opt opt))
                                                  (when (fn? close-cb!) (close-cb!)))}))))]
      [labelled-input/view
       {:data-type :data.type/ref-multi
        :label (case target-type
                 :entity.type/person (loc/tr :association-select-type-person)
                 (loc/tr :association-select-type))
        :options (->> association-type-options
                      (map (fn [opt]
                             {:value (pr-str (:key opt))
                              :label (:label opt)})))
        :value association-types
        :on-change (fn [_selected-values selected-options]
                     (swap! state assoc :association-types selected-options))}]
      [labelled-input/view
       {:label (loc/tr :association-add-source-comment)
        :data-type :data.type/text-multiline
        :value (get @state :source-comment)
        :on-change (fn [new-value]
                     (swap! state assoc :source-comment new-value))}]]]))
